{
  "de": {
    "locale_field": {
      "fallback_tooltip": "Wenn für diese Sprache kein Text eingegeben wird, wird dieser Standardtext als Fallback verwendet.",
      "translated_in": "Übersetzt in"
    }
  }
}
